import api from './api';

export const eventService = {
  getAllEvents: (params) => api.get('/events', { params }),
  getEventById: (id) => api.get(`/events/${id}`),
  getEventWithParticipations: (id) => api.get(`/events/${id}/with-participations`),
  createEvent: (data) => api.post('/events', data),
  updateEvent: (id, data) => api.put(`/events/${id}`, data),
  deleteEvent: (id) => api.delete(`/events/${id}`),
  uploadBanner: (eventId, formData) => api.post(`/events/${eventId}/banner`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  removeBanner: (eventId) => api.delete(`/events/${eventId}/banner`),
  registerForEvent: (id) => api.post(`/events/${id}/register`),
  updateParticipationStatus: (participationId, status) => 
    api.put(`/event-participations/${participationId}/status`, { status }),
  deleteParticipation: (participationId) => api.delete(`/event-participations/${participationId}`),
};
